<div [ngClass]="sessionStarted ? 'startedSession' : 'noStartedSession'"
 style="display: flex; flex-direction: column;">   <!-- (header + breadcrum + footer + margins) -->
<mat-card class="schoolsTable" [ngStyle]="{'margin-bottom': sessionStarted ? '24px' : '0px'}">
  <mat-card-content>
<div class="privacy-policy">
  <h2>SUNRISE Digital Programme Privacy Policy</h2>
  <p>
    This Privacy Policy explains how personal data is collected, processed, and protected in the context of the
    <strong>SUNRISE digital programme</strong>, implemented across eight European countries and Switzerland.
    It is issued pursuant to Articles 13 and 14 of the General Data Protection Regulation (EU) 2016/679 (GDPR).
  </p>
  <p>Your participation in the SUNRISE programme is entirely voluntary. Please read this Privacy Policy carefully.</p>

  <h3>Identity and contact details of the personal data Controllers</h3>
  <p>
    The SUNRISE digital programme operates under a <strong>Joint Controllership Agreement</strong> for the management of personal data,
    which involves the research institutions and organisations that are Parties to the SUNRISE Project (EU Grant Agreement 101136829). According to that agreement, 
    these organisations collectively determine the purposes and means of processing and share responsibility for ensuring compliance with data protection law, 
    while playing diverse roles.
  </p>
  <ul>
    <li><strong>Project Coordinator:</strong> CERTH (Ethniko Kentro Erevnas Kai Technologikis Anaptyxis), based in Greece.</li>
    <li><strong>Project’s Pilot Administrators:</strong> Responsible for pilot implementation in each participating country, as indicated in the List below.</li>
    <li><strong>Project’s Module/Application Operators:</strong> Responsible for specific digital tools and technical components, as indicated in the List below.</li>
  </ul>
  <p style="text-decoration: underline;"><strong>How to get in contact:</strong> </p>
    <p>For any questions or request regarding this Privacy Policy or the processing of your personal data, 
    you may contact <strong>CERTH’s DPO (dpo&#64;certh.gr) or the DPO of any other listed SUNRISE partner (see List below)</strong>. 
    Any partner you contact will forward and coordinate your request internally to ensure it is addressed.
  </p>

  <h4>List of Joint Controllers and Data Protection Officers</h4>
  <table>
    <thead>
      <tr>
        <th>Role</th>
        <th>Organisation & Address</th>
        <th>Contact E-Mail</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Sunrise Project Coordinator</td>
        <td>CERTH – Ethniko Kentro Erevnas Kai Technologikis Anaptyxis, Charilaou Thermi Road 6 Km, Thermi Thessaloniki 57001, Greece</td>
        <td><a href="mailto:dpo@certh.gr">dpo&#64;certh.gr</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Belgium And Module Operator</td>
        <td>UGENT – Universiteit Gent, Sint-Pietersnieuwstraat 25, B-9000 Gent, Belgium</td>
        <td><a href="mailto:privacy@ugent.be">privacy&#64;ugent.be</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Cyprus</td>
        <td>PASYKAF – Pagkyprios Syndesmos Karkinopathōn kai Filon 1986, 2 Chalkanoros str, Nicosia, 1687, Cyprus</td>
        <td><a href="mailto:nicolas@pasykaf.org">nicolas&#64;pasykaf.org</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Greece and Module Operator</td>
        <td>HMU – Hellenic Mediterranean University, Estavromenos, Heraklion, 71004, Greece</td>
        <td><a href="mailto:kkoutra@hmu.gr">kkoutra&#64;hmu.gr</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Italy</td>
        <td>FAVO – Federazione Italiana delle Associazioni di Volontariato in Oncologia, Via Barberini 11, 00187 Roma, Italy</td>
        <td><a href="mailto:dpo@favo.it">dpo&#64;favo.it</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Romania</td>
        <td>IOCN – Institutul Oncologic Prof. Dr. Ion Chiricuta Cluj-Napoca, Strada Republicii 34-36, Cluj Napoca, 400015, Romania</td>
        <td><a href="mailto:larisa.bobocea@iocn.ro">larisa.bobocea&#64;iocn.ro</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Slovenia</td>
        <td>AMEU – Alma Mater Europaea, Slovenska Ulica 17, Maribor, 2000, Slovenia</td>
        <td><a href="mailto:sunrise@almamater.si">sunrise&#64;almamater.si</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Spain (Basque)</td>
        <td>BBHRI – Instituto de Investigación Sanitaria Biobizkaia, Plaza de Cruces SN, 48903 Barakaldo Bizkaia, Spain</td>
        <td><a href="mailto:dpd@bio-bizkaia.eus">dpd&#64;bio-bizkaia.eus</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Spain (Valencia)</td>
        <td>FISABIO – Fundación para el Fomento de la Investigación Sanitaria y Biomédica de la Comunitat Valenciana, Calle Micer Masco 31, 46010 Valencia, Spain</td>
        <td><a href="mailto:esther.almenar@fisabio.es">esther.almenar&#64;fisabio.es</a></td>
        </tr>
        <tr>
        <td>Pilot Administrator – Switzerland and Module Operator</td>
        <td>ISGF – Stiftung für Sucht- und Gesundheitsforschung, Konradstrasse 32, 8005 Zürich, Switzerland</td>
        <td><a href="mailto:datenschutz@isgf.uzh.ch">datenschutz&#64;isgf.uzh.ch</a></td>
        </tr>
        <tr>
        <td>Module Operator</td>
        <td>BRIDG – Arinimi on Bridg OU, Harju Maakond Lasnamae Linnaosa Loots, Tallin, 11415, Estonia</td>
        <td><a href="mailto:safe@safe-lopd.com">safe&#64;safe-lopd.com</a></td>
        </tr>
        <tr>
        <td>Module Operator</td>
        <td>AUTH – Aristotelio Panepistimio Thessalonikis, KEDEA Building, Tritis Septemvriou, Thessaloniki, 54636, Greece</td>
        <td><a href="mailto:data.protection@auth.gr">data.protection&#64;auth.gr</a></td>
        </tr>
        <tr>
        <td>Module Operator</td>
        <td>PARTICLE – Rua da Venezuela Nº 29 -14E, Lisbon, 1500-618, Portugal</td>
        <td><a href="mailto:barbara@particle-summary.pt">barbara&#64;particle-summary.pt</a></td>
        </tr>
        <tr>
        <td>Module Operator</td>
        <td>GEZOND LEVEN – G Schildknechtstraat 9, Brussels, 1020, Belgium</td>
        <td><a href="mailto:dpo@gezondleven.be">dpo&#64;gezondleven.be</a></td>
        </tr>
        <tr>
        <td>Authorised Recipient</td>
        <td>PBY – PredictBy Research and Consulting S.L., CL Llacuna num.118 P.1 PTA.1, 08018 Barcelona, Spain</td>
        <td><a href="mailto:administration@predictby.com">administration&#64;predictby.com</a></td>
        </tr>
        <tr>
        <td>Authorised Recipient</td>
        <td>OSA – Servicio Vasco de Salud Osakidetza, Álava 45, 01006 Vitoria-Gasteiz, Spain</td>
        <td><a href="mailto:dpd@bio-bizkaia.eus">dpd&#64;bio-bizkaia.eus</a></td>
        </tr>
        <tr>
        <td>Authorised Recipient</td>
        <td>EA – Ellinogermaniki Agogi Scholi Panagea Savva AE, Dimitriou Panagea Str., Pallini, 15351, Greece</td>
        <td><a href="mailto:gdpr@ea.gr">gdpr&#64;ea.gr</a></td>
        </tr>
        <tr>
        <td>Authorised Recipient</td>
        <td>YCE – Fundatia Youth Cancer Europe, Calea Manastur 42B, Cluj Napoca, 400372, Romania</td>
        <td><a href="mailto:katie@youthcancereurope.org">katie&#64;youthcancereurope.org</a></td>
        </tr>
      
     
    </tbody>
  </table>

  <h3>Categories of Data Subjects</h3>
  <p>Personal data may be processed for the following categories:</p>
  <ul>
    <li>Students (including minors), who directly use the digital programme.</li>
    <li>Parents or legal guardians, mainly for consent and relevant communication.</li>
    <li>Educators, who guide students and interact directly with the programme.</li>
  </ul>


<h3>Categories of Personal data</h3>
<p>We process both general and special categories of personal data:</p>
<ul>
  <li><strong>General personal data:</strong> names, demographic information (age, gender, language), email addresses, phone numbers (SmartCoach only).</li>
  <li><strong>Special categories of personal data (Art. 9 GDPR):</strong> health-related data, psychological profiles, behavioural and socioeconomic conditions.</li>
  <li><strong>Minors’ personal data:</strong> processed with parental/guardian consent, as required by national law.</li>
</ul>
<p>Personal data is collected primarily from students directly, and in some cases via educators (for class profiles, and in pseudonymized format only). No data is inferred beyond the declared purposes.</p>

<h3>Purposes of the processing of personal data</h3>
<p>The personal data collected is processed to:</p>
<ul>
  <li>Deploy and adapt SUNRISE digital tools for cancer prevention.</li>
  <li>Evaluate effectiveness and cost-effectiveness of the programme.</li>
  <li>Validate and improve the SUNRISE digital programme.</li>
  <li>Aggregate and analyse behavioural change outcomes.</li>
  <li>Produce anonymised research outputs.</li>
</ul>

<h3>Legal basis</h3>
<p>Personal data processing is based on:</p>
<ul>
  <li><strong>Art. 6(1)(a) GDPR:</strong> freely given, explicit consent.</li>
  <li><strong>Art. 9(2)(a) GDPR:</strong> explicit consent for special categories of personal data.</li>
</ul>

<h3>Voluntary nature of the personal data processing and consequences</h3>
<p>Providing personal data for the purposes of the SUNRISE digital programme is entirely voluntary. <strong>You may withdraw your consent at any time</strong>. Without consent, participation in the programme is not possible. No other consequences apply.</p>
<p>Mandatory data fields are those necessary for registration (name, email, age, country, and where applicable, parent information). Optional data relate to demographic or behavioural questions within the questionnaires. Refusal to provide mandatory data prevents participation, without other consequences.</p>

<h3>Means of processing and safeguards</h3>
<p>Personal data is processed through different modules (e.g., Authentication & Registration, Authoring Tool, SmartCoach, E-Consent).</p>
<p>Key safeguards include:</p>
<ul>
  <li>Encryption (AES-256, TLS).</li>
  <li>Pseudonymisation (unique IDs, keys stored separately).</li>
  <li>Role-based access controls.</li>
  <li>Secure servers (ISO 27001 where applicable).</li>
  <li>Sub-processors (e.g., Pathmate Technologies AG and 360Dialog) bound by GDPR safeguards including Standard Contractual Clauses.</li>
</ul>
<p>Personally identifiable information (such as names, emails) is never shared or disclosed across partners; pseudonymized IDs are used instead.</p>
<p>Current sub-processors: (i) Pathmate Technologies AG (Switzerland), SmartCoach backend; (ii) 360Dialog (Germany), WhatsApp Business provider. Both operate under GDPR-compliant contracts with ISGF. No other sub-processors are used.</p>

<h3>Recipients</h3>
<p>Your data may be shared only among <strong>authorised SUNRISE partners</strong>, acting as joint controllers, and where needed with approved sub-processors under contractual safeguards.</p>
<p>No data will be shared with unauthorised third parties or for commercial purposes.</p>
<h3>International Data Transfers</h3>
<ul>
    <li>Data is processed within the <strong>EU/EEA</strong> and in <strong>Switzerland</strong>, which has an EU adequacy decision.</li>
    <li>For sub-processors outside EU/EEA, Standard Contractual Clauses and equivalent safeguards apply. A copy of the applicable Standard Contractual Clauses may be requested by contacting any DPO listed in this Policy.</li>
</ul>
<h3>Retention Periods</h3>
<p>Personal data will be kept only for as long as necessary for research and operational purposes of the SUNRISE digital programme , 
    in line with the principles of data minimisation and storage limitation. All <strong>personal data</strong> will be securely deleted <strong>within 6 months after the project ends (expected April 2028)</strong>, unless earlier deletion is requested by you or a competent authority, or a longer retention period is required by a competent authority based on applicable EU or national legal obligations.</p>
<ul>
    <li><strong>Registration and consent data</strong> will be maintained for the duration of the project and securely deleted within six (6) months after the official project end date (expected 30 April 2028).</li>
    <li><strong>Questionnaire responses and interaction data:</strong> retained in pseudonymised form for the duration of the project and deleted within six (6) months after the project’s conclusion.</li>
    <li><strong>E-consent and paper consent forms:</strong> stored securely for the duration of the project and deleted within six (6) months after its completion, unless earlier erasure is requested by the data subject.</li>
    <li><strong>Administrative and financial records (non-personal data):</strong> may be retained for up to five (5) years after the project’s completion to comply with European Commission audit and reporting obligations.</li>
    <li><strong>Research data (anonymised datasets):</strong> may be retained long-term in trusted repositories for scientific and statistical purposes, in compliance with Article 89 of the GDPR.</li>
</ul>

<h3>Automated Decision-Making and Profiling</h3>
<p>No automated decisions producing legal or significant effects are foreseen. Some digital tools (e.g., SmartCoach) may personalise educational content. Such adaptation is educational and not profiling under Art. 22 GDPR. The SmartCoach application adapts educational messages based on participants’ questionnaire responses (e.g., age, lifestyle habits, smoker/non-smoker). 
    This personalization is limited to tailoring the content to the user’s learning needs and does not produce legal or significant effects.</p>

<h3>Rights of Data Subjects</h3>
<p>As a Data Subject, you may exercise your rights under Articles 15–22 GDPR:</p>
<ul>
  <li>Access, rectification, erasure of your personal data.</li>
  <li>Restriction or objection to processing.</li>
  <li>Data portability.</li>
  <li>Withdrawal of consent at any time.</li>
  <li>Right to file a complaint with your national Data Protection Authority.</li>
  </ul>
  <p>Requests with regards to the exercise of any of these rights may be made to CERTH or any SUNRISE partner’s DPO via email to any of the contacts provided in the List of of Joint Controllers and Data Protection Officers above, or via the website’s Contact site (<a href="https://thesunriseproject.eu/contact/">https://thesunriseproject.eu/contact/</a>), or by post in a sealed envelope. Responses will be provided within one month, extendable by two months if necessary due to the complexity of the request. Requests are verified through the email address or identification data provided during registration. Responses will be delivered via the same channel, and are free of charge unless manifestly unfounded or excessive (Art. 12.5 GDPR).
  </p>
  <p>
    The lead supervisory authority is the Hellenic Data Protection Authority (HDPA) (<a href="mailto:contact@dpa.gr">contact&#64;dpa.gr</a>). Data subjects may also identify contact their national Data Protection Authority using the list available at <a href="https://edpb.europa.eu/about-edpb/board/members_en">https://edpb.europa.eu/about-edpb/board/members_en</a>.
  </p>


<h3>Minors</h3>
<p>Participation of adolescents requires additional safeguards. Where national law requires, parental or guardian consent must be obtained. Pilot Administrators are responsible for ensuring compliance in their country. Participation of minors complies with Article 8 GDPR and national laws. The minimum age for valid consent varies between 13 and 16 years depending on the country; where required, parental or guardian consent is verified electronically through the E-Consent module or via signed hard copy forms validated by the corresponding Pilot Administrator.</p>

<h3>Cookies and tracking technologies</h3>
<p>The SUNRISE Authoring tool uses cookies to collect usage analytics. Specifically, Google Analytics cookies are employed to collect anonymous and aggregated information about how users interact with the app. This data allows to optimize performance and monitor usage patterns by countries.</p>
<p>Users may configure their browser settings to block or delete cookies at any time. For further details on how Google Analytics uses cookies, please consult Google’s Cookie Policy.
</p>

<h3>Version control and languages</h3>
<p>This Privacy Policy is reviewed regularly and updated as needed. The latest version will always be accessible through the SUNRISE front-end application and website. It will be available in all project languages, however, in case of any discrepancies or interpretation doubts, the English version shall prevail.</p>
  <p><em>Last updated: October 2025.</em></p>
</div>

  </mat-card-content>
</mat-card>
    

</div>